// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
exports.push([module.id, "@import url(https://fonts.googleapis.com/css2?family=Open+Sans:ital,wght@0,400;0,700;1,400;1,700&display=swap);"]);
exports.push([module.id, "@import url(https://fonts.googleapis.com/css2?family=Poppins:ital,wght@0,200;0,400;0,700;1,200;1,400;1,700&display=swap);"]);
// Module
exports.push([module.id, "body #pp-content,html #pp-content{position:relative;height:100%;min-height:100%;width:100%;min-width:320px;-webkit-font-smoothing:antialiased;-moz-osx-font-smoothing:grayscale}body #pp-body,html #pp-body{margin:0}", ""]);
// Exports
module.exports = exports;
